import {LandingsConst} from 'consts';

export const isLandingPage = (isFakeUrl?: boolean, isSupportAnalytics?: boolean) => {
    const path = window?.location?.pathname?.replaceAll('/', '');
    return isFakeUrl
        ? path === 'r'
        : isSupportAnalytics ? false : LandingsConst.indexOf(`/${path}`) !== -1;
};
